import React from "react";
import Box from "@material-ui/core/Box";
import { useTeamsContext } from "../../../../state/teams/context";
import TeamButton from "../../../team/components/TeamButton";
import { useGameContextContext } from "../../../../state/game-context/context";
import selectorStyles from "./styles/SelectorStyles";

const TeamSelector = ({ selected, onSelected }) => {
	const { state } = useTeamsContext();
	const homeTeam = state.homeTeam();
	const awayTeam = state.awayTeam();

	const { state: gameContextState } = useGameContextContext();
	const swapTeams = gameContextState.swapTeams();
	const classes = selectorStyles({ swapTeams });

	return (
		homeTeam &&
		awayTeam && (
			<Box className={classes.teamSelectorBox}>
				<TeamButton
					id="away-selection-btn"
					team={awayTeam}
					selected={selected && awayTeam.id === selected.id}
					onSelected={onSelected}
				/>
				<TeamButton
					id="home-selection-btn"
					team={homeTeam}
					selected={selected && homeTeam.id === selected.id}
					onSelected={onSelected}
				/>
			</Box>
		)
	);
};

export default TeamSelector;
